export const API_HOST = '';
export const WS_URI = '';
export const TUS_URI = '';
export const IS_DEV = process.env.REACT_APP_MODE === 'DEVELOPMENT';
